// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VwyR","buttons":"styles_buttons__3EkKt"};